

import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import AnimationWrapper from './animationWrapper.js';
import ApuaWhiteTextLogo from '../ImageAssets/Apua_New_Logo.png';
import Constants from '../Utils/constants.json';

class PaymentReceiptModalComponent extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount(){
    
    }

    populateAccountSummary(){
        return(
        <div className="col-md-12 m-0 p-0 customerSummaryBox">
            <div className="col-md-12 m-0 summaryBoxHeading">Account Summary</div>
            <div className="col-md-12 m-0 p-0 py-2">
                <div className="col-12 m-0 p-0 d-flex justify-content-between align-items-center pb-2">
                    <div className="col-3 summaryBoxLabel">{this.props.locales.BillPaymentPaymentDateTable}</div>
                    <div className="col-9 summaryBoxData" style={{ wordBreak: 'break-word' }}>: &nbsp;{this.props.paymentDetails.paymentDate}</div>
                </div>
                <div className="col-12 m-0 p-0 d-flex justify-content-between align-items-center pb-2">
                    <div className="col-3 summaryBoxLabel">{this.props.locales.BillPaymentPaymentReferTable}</div>
                    <div className="col-9 summaryBoxData">: &nbsp;{this.props.paymentDetails.paymentReferance}</div>
                </div>
                <div className="col-12 m-0 p-0 d-flex justify-content-between align-items-center pb-2">
                    <div className="col-3 summaryBoxLabel">{this.props.locales.BillPaymentAmtPaidTable} ({Constants.dollarSign})</div>
                    <div className="col-9 summaryBoxData">: &nbsp;{this.props.paymentDetails.amountPaid}</div>
                </div>
                <div className="col-12 m-0 p-0 d-flex justify-content-between align-items-center pb-2">
                    <div className="col-3 summaryBoxLabel">{this.props.locales.BillPaymentPaymentModeTable}</div>
                    <div className="col-9 summaryBoxData">: &nbsp;{this.props.paymentDetails.paymentMode}</div>
                </div>
                <div className="col-12 m-0 p-0 d-flex justify-content-between align-items-center pb-2">
                    <div className="col-3 summaryBoxLabel">{this.props.locales.BillPaymentOutstandingTable} ({Constants.dollarSign})</div>
                    <div className="col-9 summaryBoxData">: &nbsp;{this.props.paymentDetails.outstandingAfter}</div>
                </div>
                <div className="col-12 m-0 p-0 d-flex justify-content-between align-items-center pb-2">
                    <div className="col-3 summaryBoxLabel">{this.props.locales.BillPaymentCommentTable}</div>
                    <div className="col-9 summaryBoxData">: &nbsp;{this.props.paymentDetails.comment}</div>
                </div>
            </div>
        </div>
        )
    }

    populateContactSummary() {
        return (
            <div className="col-md-12 m-0 p-0 contactSummaryBox">
                <div className="col-md-12 m-0 summaryBoxHeading">Contact Information</div>
                <div className="col-md-12 m-0 p-3" style={{fontSize: 12}}>
                    <div>480-7000 - Main Office</div>
                    <div>727-2782 - Customer Service</div>
                    <div>462-2782 - Fax</div>
                    <div>811 - Fault Reports</div>
                    <div>www.apua.ag - Online</div>
                </div>
            </div>
        )
    }

    render() {
        return (
            <div>
                {this.props.isVisible ? <div className="commonPopupFormBackDrop animated fadeIn"></div> : null}
                <AnimationWrapper.cssTransition isVisible={this.props.isVisible}>
                    <div className='paymentReceiptDiv col-md-12 p-5'>
                        <div className='justify-content-between col-md-12 row'>
                            <img src={ApuaWhiteTextLogo} alt="" />
                            <div className='col-md-6 row'>
                                <div className="col-12 m-0 p-0 d-flex align-items-center pb-2 text-right justify-content-end">
                                    <div className="summaryBoxLabel">Account ID</div>
                                    <div className="summaryBoxData">: &nbsp;{this.props.accountId}</div>
                                </div>
                                <div className="col-12 m-0 p-0 d-flex align-items-center pb-2 text-right justify-content-end">
                                    <div className="summaryBoxLabel">{this.props.locales.BillingAndPaymentreceiptNumArryHeader}</div>
                                    <div className="summaryBoxData">: &nbsp;{this.props.paymentDetails.paymentReferance}</div>
                                </div>
                            </div>
                        </div>
                        
                        <div className='col-md-12 row py-3'>
                            <div className='col-md-6'>
                                {this.populateContactSummary()}
                            </div>
                            <div className='col-md-6'>
                                {this.populateAccountSummary()}
                            </div>
                        </div>
                    </div>
                </AnimationWrapper.cssTransition>
            </div>
        );
    }
}
const mapStateToProps = (state, ownProperties) => {
    return {
        locales: state.locales
    }
}

PaymentReceiptModalComponent.defaultProps = {
    isVisible: false,
    accountId: '',
    paymentDetails: {},
}

PaymentReceiptModalComponent.propTypes = {
    isVisible: PropTypes.bool,
    accountId: PropTypes.string,
    paymentDetails: PropTypes.object
}


const PaymentReceiptModalComponentContainer = connect(
    mapStateToProps
)(PaymentReceiptModalComponent)

export default PaymentReceiptModalComponentContainer;
